"use strict";

module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};


/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/~/chart.js/src/charts/Chart.Doughnut.js
 ** module id = 217
 ** module chunks = 0
 **/